import {DrawFrmThing} from "../../../drawfrm/DrawFrmThing";
import {inches, lineBlueHeavy} from "../../../const";
import {FrmShape} from "../../../drawfrm/FrmShape";
import {FrameProfileArgs} from "./ProfileArgs";
import {FrmRefPoint} from "../../../drawfrm/FrmRefPoint";

// Drywall (DBL Bend)
export class FrameProfileDW extends DrawFrmThing {

    primaryDoorAnchor = new FrmRefPoint();
    // top of the outer face; the frame-profile view aligns a clamshell mullion on this.
    faceAnchor = new FrmRefPoint();

    constructor(args: FrameProfileArgs) {
        super();
        const {detail, jambDepth, jambFace, view, app, left, swingIn, clamshell, hideFaces, hideFaceDims, flipY} = args;

        const shape = new FrmShape(`frameProfile:DW:${left ? "left" : "right"}`, {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: app,
        });
        shape.strokeColor = lineBlueHeavy;
        shape.horizontalDimensionSide = left ? "left" : "right";
        if (!left) shape.invertX();
        if(swingIn !== !!flipY) shape.invertY();

        //  __
        // |  |-----------|       top return hook + top face
        // |__|           |
        //                |
        //                |---|   double-bend stop (out, down, back in)
        //                |   |
        //                |---|
        //  __            |
        // |  |-----------|       bottom face + bottom return hook
        // |__|

        const hookLip = 0.5 * inches;  // horizontal lip of the drywall return
        const hookDrop = 0.5 * inches; // depth of the drywall return pocket
        const face = 2 * inches;       // face width
        const neck = 30;               // throat between face and stop (flexes with jamb depth)
        const stopOut = 0.5 * inches;  // how far the stop steps out
        const stopFace = 2 * inches;   // height of the stop

        // top return hook (lip tip -> left -> up), opening to the right
        shape.start(0, 0);
        const topLip = shape.lineTo(-hookLip, 0);
        const topHook = shape.lineTo(0, -hookDrop);
        if(clamshell) { topLip.setPenUp(); topHook.setPenUp(); }
        else { topLip.linkDimension(detail.drywallLip, "extended"); topHook.linkDimension(detail.drywallHookDrop, "extended"); }

        // top face
        const topFace = shape.lineTo(face, 0).linkDimension(jambFace);

        // upper throat
        const upperNeck = shape.lineTo(0, neck);

        // double-bend stop (step out, down, step back in)
        const stopOutLine = shape.lineTo(stopOut, 0);
        shape.lineTo(0, stopFace)
        const stopInLine = shape.lineTo(-stopOut, 0);

        // lower throat
        const lowerNeck = shape.lineTo(0, neck).linkDimension(detail.rabbetDepth, "extended");

        this.primaryDoorAnchor.setLocalPoint(lowerNeck.pointA);

        // bottom face
        const bottomFace = shape.lineTo(-face, 0);

        // bottom return hook (down -> right lip), mirrors the top
        const bottomHook = shape.lineTo(0, -hookDrop);
        const bottomLip = shape.lineTo(hookLip, 0);
        if(clamshell) { bottomHook.setPenUp(); bottomLip.setPenUp(); }

        // mirror rules: faces, throats, stop steps and hook lips stay matched
        bottomFace.dimMatches(topFace);
        lowerNeck.dimMatches(upperNeck);
        stopInLine.dimMatches(stopOutLine);
        bottomLip.dimMatches(topLip);

        // jamb depth drives the overall throat (face-to-face)
        shape.addDimension(topFace.getStartpoint(), bottomFace.getEndpoint(), jambDepth);

        // clamshell secondary side: omit the top/bottom faces so the primary side's
        // faces cap the merged mullion (avoids a doubled/gapped cap).
        if(hideFaces) { topFace.setPenUp(); bottomFace.setPenUp(); }
        if(hideFaces || hideFaceDims) shape.hideDimensionsForVars([jambFace, jambDepth]);
        this.faceAnchor.setLocalPoint(topFace.getStartpoint());
        shape.done();
    }
}
